export const marqueeItems = [
  "KUNDLI",
  "HOROSCOPE",
  "ZODIAC SIGN",
  "BIRTH CHART",
  "TAROT CARD",
  "CONSULTATIONS",
  "YANTRAS",
  "KUNDLI MATCHING",
  "RUDRAKSH",
  "REMEDIES",
];

export const serviceItems = [
  {
    id: 1,
    title: "Astrology",
    description:
      "Explore the insights written in your stars. Discover personalised astrological insights, explore your Kundli and horoscopes, and connect with astrologers to discuss the questions that matter to you.",
    cta: "Explore Astrology",
    to: "/download-app",
    icon: "/images/s-icon2.svg",
  },
  {
    id: 2,
    title: "Numerology",
    description:
      "Discover the meaning behind the numbers. Explore numerology-based insights and connect with numerologists for personalised readings.",
    cta: "Explore Numerology",
    to: "/download-app",
    icon: "/images/s-icon4.svg",
  },
  {
    id: 3,
    title: "Tarot",
    description:
      "A different perspective on your questions. Discover tarot readings and explore symbolic interpretations that can support reflection and personal insight.",
    cta: "Explore Tarot",
    to: "/download-app",
    icon: "/images/s-icon1.svg",
  },
  {
    id: 4,
    title: "Spiritual Guidance",
    description:
      "Connect with traditions that hold meaning for you. Explore spiritual guidance, connect with pujaris and discover puja services and traditional spiritual practices.",
    cta: "Explore Spiritual Services",
    to: "/download-app",
    icon: "/images/s-icon3.svg",
  },
  {
    id: 5,
    title: "Holistic Wellness",
    description:
      "Make space for yourself. Discover life coaching, wellness experiences and opportunities for reflection and personal growth.",
    cta: "Explore Wellness",
    to: "/download-app",
    icon: "/images/s-icon1.svg",
  },
  {
    id: 6,
    title: "Astrology & Spiritual Products",
    description:
      "Explore products inspired by tradition. Discover gemstones, yantras and other products associated with astrology and spiritual practices.",
    cta: "Explore the Store",
    to: "/remedies-store",
    icon: "/images/store2.png",
  },
];

export const remediesStoreItems = [
  {
    id: 1,
    title: "Yantras",
    icon: "/images/store1.png",
  },
  {
    id: 2,
    title: "Gemstones",
    icon: "/images/store2.png",
  },
  {
    id: 3,
    title: "Rudraksha",
    icon: "/images/store3.png",
  },
  {
    id: 4,
    title: "Online Puja",
    icon: "/images/store4.png",
  },
];
